export const configsContext = 'configs';
